import { useState } from 'react';
import ReactStickyPolyfill from '../../components/react-sticky-polyfill/ReactStickyPolyfill';
import DocLeftMenu from './components/doc-menu/components/doc-left-menu/DocLeftMenu';
import DocRightMenu from './components/doc-menu/components/doc-right-menu/DocRightMenu';
import DocHelp from 'src/components/doc-help/DocHelp';
import DocArticle from './components/doc-article/DocArticle';
import useDocument from './documentHooks';
import { IDocumentMenuItem, IDocumentParams } from './type';
import classNames from 'classnames';
import Selection, { getSelection } from '../selection/Selection';

const DocContent: React.FC<{
    currentList: IDocumentMenuItem[];
    pageProps: IDocumentParams;
    currentValue: string;
}> = props => {
    const { leftMenuShow, toggleLeftMenuShow, docArticleRef, docArticleHook, docMenuHooks } = useDocument(
        props.pageProps
    );
    const [selectedText, setSelectedText] = useState<string>('');
    const { currentList, currentValue } = props;
    const pathnameArr = window.location.pathname.split('/');
    const docName = pathnameArr.length > 0 ? pathnameArr[1] : 'lite';

    return (
        <>
            <div
                className={classNames('paddle-doc-page-container', {
                    'paddle-doc-page-container-no-left': docMenuHooks.left.menuList.length === 0,
                    'paddle-doc-page-container-no-right': docMenuHooks.right.menuList.length === 0
                })}
            >
                <div
                    className={classNames('paddle-doc-page-main', {
                        'paddle-doc-page-left-menu-show': leftMenuShow
                    })}
                >
                    <div className="paddle-doc-page-left-background" />
                    <div className="paddle-doc-page-left">
                        <ReactStickyPolyfill>
                            <div className="paddle-doc-page-left-menu-wrap">
                                <DocLeftMenu {...{ ...docMenuHooks.left, menuList: currentList }} />
                            </div>
                        </ReactStickyPolyfill>
                    </div>
                    <div className="paddle-doc-page-right">
                        <ReactStickyPolyfill>
                            <div className="paddle-doc-page-right-menu-wrap">
                                <div className="paddle-doc-page-right-menu-index">目录</div>
                                <DocRightMenu {...docMenuHooks.right} />
                            </div>
                        </ReactStickyPolyfill>
                    </div>
                    <div className="paddle-doc-page-center" onMouseUp={e => setSelectedText(getSelection(e))}>
                        <ReactStickyPolyfill>
                            <div className="paddle-doc-page-left-menu-switch-wrap">
                                <div className="paddle-doc-page-left-menu-switch" onClick={toggleLeftMenuShow} />
                            </div>
                        </ReactStickyPolyfill>
                        <DocArticle ref={docArticleRef} {...docArticleHook} />
                        <DocHelp currentVersion={currentValue} docName={docName} />
                        <a
                            className="paddle-doc-page-center-github"
                            href={
                                window.location.pathname.includes('lite')
                                    ? 'https://github.com/PaddlePaddle/Paddle-Lite/tree/release/v2.11/docs'
                                    : 'https://github.com/PaddlePaddle/Paddle-Inference-Demo/tree/master/docs'
                            }
                            target="_blank"
                            rel="noreferrer"
                        >
                            Edit on Github
                        </a>
                    </div>
                </div>
            </div>
            <Selection selectedText={selectedText} docVersion={props.currentValue} />
        </>
    );
};

export default DocContent;
